import { FormGroup } from '@angular/forms';
import { ModelBase } from '../../core/model/model-base';
import { TenantCategory, TenantCategoryToString, TenantState, TenantStateToString } from './const/enums';
import { ContactIdKind } from './contact';
import { SWEDISH_CULTURE } from '../../core/service/language.service';

export class Representative extends ModelBase {
  constructor(leaseAgreementId?: string) {
    super();

    this.leaseAgreementId = leaseAgreementId ?? '';
    this.contactRegistrationKey = '';
    this.contactId = '';
    this.contactIdentification = '';

    this.contactName = '';
    this.contactEmail = '';
    this.contactPhoneNumber = '';
    this.contactState = TenantState.Registered;

    this.faultNotificationsAccess = false;
    this.invoicesAccess = false;
    this.dwellingInspectionsAccess = false;
    this.leaseAgreementsAccess = false;
    this.documentsAccess = false;

    this.inviteCultureName = SWEDISH_CULTURE;
  }

  leaseAgreementId: string;
  contactCategory: TenantCategory;
  contactName: string;
  contactIdentification: string;
  contactId: string | null;
  contactIdentificationType: ContactIdKind;
  contactEmail: string;
  contactPhoneNumber: string;
  contactRegistrationKey: string;
  faultNotificationsAccess: boolean;
  invoicesAccess: boolean;
  dwellingInspectionsAccess: boolean;
  leaseAgreementsAccess: boolean;
  documentsAccess: boolean;
  contactState: TenantState;
  inviteCultureName: string; // sending registration key culture

  get contactStateCaption(): string {
    return TenantStateToString(this.contactState);
  }

  get contactCategoryCaption() {
    return TenantCategoryToString(this.contactCategory);
  }
}

export interface AccessCheckboxData {
  currentValue: boolean;
  changeMethod: () => void;
  connectedForm?: FormGroup;
}
